import React, { HTMLProps, useId } from "react";

export const BoxIcon: React.FC<HTMLProps<SVGSVGElement>> = (props) => {
  const a = useId();
  const b = useId();
  const c = useId();
  const d = useId();
  const e = useId();
  const f = useId();
  const g = useId();
  const h = useId();
  const i = useId();
  const j = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 250 170"
      {...props}
    >
      <defs>
        <linearGradient id={d}>
          <stop
            offset={0}
            style={{
              stopColor: "#dcc06d",
              stopOpacity: 1,
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#af7e32",
              stopOpacity: 1,
            }}
          />
        </linearGradient>
        <linearGradient id={c}>
          <stop
            offset={0}
            style={{
              stopColor: "#dcc06d",
              stopOpacity: 1,
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#af7e32",
              stopOpacity: 1,
            }}
          />
        </linearGradient>
        <linearGradient id={b}>
          <stop
            offset={0}
            style={{
              stopColor: "#dcbb6c",
              stopOpacity: 1,
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#af7e32",
              stopOpacity: 1,
            }}
          />
        </linearGradient>
        <linearGradient id={a}>
          <stop
            offset={0}
            style={{
              stopColor: "#5b230a",
              stopOpacity: 1,
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#8c5e22",
              stopOpacity: 1,
            }}
          />
        </linearGradient>
        <linearGradient
          xlinkHref={`#${b}`}
          id={e}
          x1={382.652}
          x2={93.575}
          y1={408.689}
          y2={351.63}
          gradientUnits="userSpaceOnUse"
        />
        <linearGradient
          xlinkHref={`#${a}`}
          id={f}
          x1={703.976}
          x2={391.707}
          y1={327.348}
          y2={304.034}
          gradientUnits="userSpaceOnUse"
        />
        <linearGradient
          xlinkHref={`#${c}`}
          id={h}
          x1={241.541}
          x2={431.204}
          y1={170.983}
          y2={69.749}
          gradientUnits="userSpaceOnUse"
        />
        <linearGradient
          xlinkHref={`#${d}`}
          id={i}
          x1={232.031}
          x2={540.414}
          y1={189.236}
          y2={107.635}
          gradientUnits="userSpaceOnUse"
        />
        <linearGradient
          xlinkHref={`#${d}`}
          id={j}
          x1={522.676}
          x2={517.573}
          y1={99.216}
          y2={160.57}
          gradientUnits="userSpaceOnUse"
        />
        <filter id={g}>
          <feGaussianBlur stdDeviation={0.967} />
        </filter>
      </defs>
      <g>
        <path
          d="m68.407 144.23 319.78 135.166-10.714 256.318L75 372.527l-6.593-228.296z"
          style={{
            opacity: 1,
            fill: `url(#${e})`,
            fillOpacity: 1,
            fillRule: "evenodd",
            stroke: "#000",
            strokeWidth: 1,
            strokeLinecap: "butt",
            strokeLinejoin: "round",
            strokeOpacity: 1,
          }}
          transform="matrix(.33678 0 0 .3376 -5.691 -16.583)"
        />
        <path
          d="m388.187 278.571 323.9-125.274-11.538 216.758-322.476 165.703 10.114-257.187z"
          style={{
            opacity: 1,
            fill: `url(#${f})`,
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "#000",
            strokeWidth: 1,
            strokeLinecap: "butt",
            strokeLinejoin: "round",
            strokeOpacity: 1,
          }}
          transform="matrix(.33678 0 0 .3376 -5.691 -16.583)"
        />
        <path
          d="M194.306 197.022 182.966 431.4l74.093 40.071 13.61-242.694-76.363-31.754z"
          style={{
            opacity: 0.64736843,
            color: "#000",
            fill: "#000",
            fillOpacity: 0.08641974,
            fillRule: "evenodd",
            stroke: "#fff",
            strokeWidth: 1,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            marker: "none",
            markerStart: "none",
            markerMid: "none",
            markerEnd: "none",
            strokeMiterlimit: 4,
            strokeDasharray: "none",
            strokeDashoffset: 0,
            strokeOpacity: 1,
            visibility: "visible",
            display: "inline",
            overflow: "visible",
            filter: `url(#${g})`,
          }}
          transform="matrix(.33678 0 0 .3376 -5.691 -16.583)"
        />
        <path
          d="m68.41 143.834 158.6 66.876L537.46 99.66l-135.286-40.8L68.41 143.833z"
          style={{
            fill: `url(#${h})`,
            fillOpacity: 1,
            fillRule: "evenodd",
            stroke: "#000",
            strokeWidth: 1,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            strokeOpacity: 1,
          }}
          transform="matrix(.33678 0 0 .3376 -5.691 -16.583)"
        />
        <path
          d="m232.531 213.47 155.839 65.65 323.948-125.776L537.46 99.353 232.53 213.47z"
          style={{
            fill: `url(#${i})`,
            fillOpacity: 1,
            fillRule: "evenodd",
            stroke: "#000",
            strokeWidth: 1,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            strokeOpacity: 1,
          }}
          transform="matrix(.33678 0 0 .3376 -5.691 -16.583)"
        />
        <path
          d="M194.319 197.347 511.849 91.93l63.51 18.902-304.79 118.378-76.25-31.863z"
          style={{
            opacity: 0.64736843,
            fill: `url(#${j})`,
            fillOpacity: 1,
            fillRule: "evenodd",
            stroke: "#fff",
            strokeWidth: 1,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            strokeOpacity: 1,
            filter: `url(#${g})`,
          }}
          transform="matrix(.33678 0 0 .3376 -5.691 -16.583)"
        />
        <path
          d="M537.556 100.247 225.736 210.2l8.1 3.35 303.72-113.303z"
          style={{
            opacity: 1,
            fill: "#000",
            fillOpacity: 0.63580244,
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: 1,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            strokeOpacity: 1,
          }}
          transform="matrix(.33678 0 0 .3376 -5.691 -16.583)"
        />
        <path
          d="M181.988 267.521 369.84 354.29l-2.17 116.268-188.719-93.709 3.037-109.327z"
          style={{
            opacity: 0.14210528,
            fill: "#ffe9ff",
            fillOpacity: 1,
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: 1,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            strokeOpacity: 1,
          }}
          transform="matrix(.33678 0 0 .3376 -5.691 -16.583)"
        />
        <path
          d="m186.76 276.632 176.138 82.429-.433 102.82-179.175-87.636 3.47-97.613z"
          style={{
            opacity: 0.36315792,
            fill: "#fff",
            fillOpacity: 1,
            fillRule: "evenodd",
            stroke: "#002278",
            strokeWidth: 1.89999998,
            strokeLinecap: "butt",
            strokeLinejoin: "round",
            strokeMiterlimit: 4,
            strokeDasharray: "none",
            strokeOpacity: 1,
          }}
          transform="matrix(.33678 0 0 .3376 -5.691 -16.583)"
        />
      </g>
    </svg>
  );
};
